
const OAUTH_GOOGLE_JAVASCRIPT_ORIGIN = process.env.OAUTH_GOOGLE_JAVASCRIPT_ORIGIN
const OAUTH_GOOGLE_URL = process.env.OAUTH_GOOGLE_URL || "https://accounts.google.com/o/oauth2/auth"
const OAUTH_GOOGLE_CLIENT_ID = process.env.OAUTH_GOOGLE_CLIENT_ID

const GOOGLE_AUTH_PARAMS = {
    protocol: "oauth2",
    access_type: null,
    response_type: "code",
    scope: ["profile", "email"],
    client_id: OAUTH_GOOGLE_CLIENT_ID,
    redirect_uri: `${OAUTH_GOOGLE_JAVASCRIPT_ORIGIN}/auth/redirect/google`
}

const OAUTH_GOOGLE_QUERY = Object
    .entries(GOOGLE_AUTH_PARAMS)
    .map(([p, v]) => {
        if (v === undefined) throw Error(`No ${p} was providen`)
        if (v === null) return p
        const value = typeof v === 'object' ? v.join(' ') : v
        return `${encodeURI(p)}=${encodeURI(value)}`
    })
    .join('&')

export const GOOGLE_AUTH_URL = `${OAUTH_GOOGLE_URL}?${OAUTH_GOOGLE_QUERY}`
